import React, { type ReactNode, useEffect } from 'react';
import { Flex, useScreenSize } from '@banhala/ui-kit';

export const ContentContainer: React.FC<{
  focused: boolean;
  children: ReactNode;
}> = props => {
  const [showOnce, setShowOnce] = React.useState(false);
  const { height: screenHeight } = useScreenSize();

  useEffect(() => {
    if (props.focused) {
      setShowOnce(true);
    }
  }, [props.focused, showOnce]);

  if (!props.focused && !showOnce) {
    return <Flex height={screenHeight}></Flex>;
  }

  return props.children;
};
